// packages/whiteboard/src/features/checkbox/checkbox-options.config.ts

import {
  FILL_ACTIONS,
  Z_ORDER_ACTIONS,
  ALIGN_ACTIONS,
  BOARD_COMMAND_ACTIONS,
  type ActionIntent,
  type ActionsMap,
  type OptionsCircleDef,
} from '../../optionsbar/optionsbar-actions.js';
import { composeOptionsCircle } from '../../optionsbar/parts/compose-options-circle.js';
import { CHECKBOX_ICON_ORDER } from './checkbox-icons.config.js';

// Optionskreis aus Einzelteilen (Checkbox = 1 + 3 + 9): Standard-Knoepfe +
// Fuellfarben + Groessen-/Icon-Picker (Stefan, 2026-08-29 — ersetzt den
// bisherigen `optionskreis-default.svg`-Platzhalter samt der alten S/M/L-
// Buttons in der (inzwischen komplett entfernten) Aktionsleiste).
const checkboxSvg = composeOptionsCircle([1, 3, 9]);

/**
 * Die drei Groessen-Knoepfe (part9: `action-checkbox-size-s/m/l`). Anders als
 * z. B. die Schriftgroesse ist das KEIN einzelner Property-Wert (der Klick
 * muss `width` UND `height` setzen) — dafuer gibt es einen Sonderfall in
 * `o2d-svg-optionsbar.element.ts` (analog zum bestehenden `text-size`-
 * Sonderfall), der `resolveProperty` fuer diesen Intent gar nicht erst
 * braucht. `value` ist hier nur der Groessen-Schluessel (S/M/L); die
 * tatsaechliche Weltgroesse wird dort ueber `checkboxSizesForScale(scale)`
 * zum Klick-Zeitpunkt live nachgeschlagen — exakt das, was die alte
 * Aktionsleiste bereits tat.
 */
const CHECKBOX_SIZE_ACTIONS: ActionsMap = {
  'action-checkbox-size-s': { intent: 'checkbox-size', value: 'S' },
  'action-checkbox-size-m': { intent: 'checkbox-size', value: 'M' },
  'action-checkbox-size-l': { intent: 'checkbox-size', value: 'L' },
};

/**
 * Die drei Icon-Knoepfe: SVG-Id `action-checkbox-icon-1..3` → der jeweilige
 * Icon-Schluessel, in der Reihenfolge aus `CHECKBOX_ICON_ORDER`. Gleiches
 * Muster wie `SMILEY_ICON_ACTIONS` (smiley-options.config.ts).
 */
const CHECKBOX_ICON_ACTIONS: ActionsMap = Object.fromEntries(
  CHECKBOX_ICON_ORDER.map((key, i) => [`action-checkbox-icon-${i + 1}`, { intent: 'checkbox-icon', value: key }]),
);

/**
 * Resolves an optionsbar action intent to a CheckboxObject property
 * (PRD-F2 §T14, erweitert Stefan 2026-08-29). `checkbox-size` resolviert
 * bewusst NICHT hier — der Sonderfall in `o2d-svg-optionsbar.element.ts`
 * braucht keine Property-Zuordnung, weil er zwei Properties auf einmal setzt.
 */
function resolveCheckboxProperty(intent: ActionIntent): string | null {
  switch (intent) {
    case 'fill':
      return 'color';
    case 'checkbox-icon':
      return 'icon';
    default:
      return null;
  }
}

/**
 * Checkbox-specific optionsbar definition (parts 1 + 3 + 9). Wired: fill
 * (=Farbe), Groesse (S/M/L, Sonderfall) und die drei Icon-Varianten.
 */
export const CHECKBOX_OPTIONS: OptionsCircleDef = {
  svg: checkboxSvg,
  actions: {
    ...FILL_ACTIONS,
    ...Z_ORDER_ACTIONS,
    ...ALIGN_ACTIONS,
    ...BOARD_COMMAND_ACTIONS,
    ...CHECKBOX_SIZE_ACTIONS,
    ...CHECKBOX_ICON_ACTIONS,
  },
  resolveProperty: resolveCheckboxProperty,
};
